import createHashHistory from 'history/lib/createHashHistory';
import createRouterHistory from './createRouterHistory';
export default createRouterHistory(createHashHistory);


//////////////////
// WEBPACK FOOTER
// ../~/react-router/es/hashHistory.js
// module id = 416
// module chunks = 47